import { useEffect, useState } from "react";
import {
  Box,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { ENV_CONFIG } from "../../utils/constants";
import { Print } from "@mui/icons-material";
import { IOrder } from "../../types/IOrder";
import {
  formatDate,
  getItemBriefLabel,
  printNewReceipt,
} from "../../utils/commonHelpers";
import "./style.scss";

const Order = () => {
  const [orderHistory, setOrderHistory] = useState<IOrder[]>();

  const fetchAndSetOrderHistory = async () => {
    const response = await fetch(
      `${ENV_CONFIG.BACKEND_BASE_URL}/api/pos/order/`,
    );
    const data = await response.json();
    setOrderHistory(data.results);
  };

  useEffect(() => {
    fetchAndSetOrderHistory();
  }, []);

  const handleTotalClick = (totalAmount: string) => {
    const takenByCustomer = prompt(
      `Order Amount: ${totalAmount} PKR\n\nHow much is taken by the customer?`,
    );

    if (takenByCustomer) {
      alert(`Giveback: ${Number(takenByCustomer) - Number(totalAmount)} PKR`);
    }
  };

  return (
    <Container id="order-page-container">
      <Box className="past-orders-container">
        <TableContainer component={Paper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Order ID</strong>
                </TableCell>
                <TableCell>
                  <strong>Items</strong>
                </TableCell>
                <TableCell>
                  <strong>Total</strong>
                </TableCell>
                <TableCell>
                  <strong>Created At</strong>
                </TableCell>
                <TableCell align="right">
                  <strong>Action</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(orderHistory || []).map((order) => (
                <TableRow
                  key={order.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {order.id.split("-")[4]} ({order.order_number})
                  </TableCell>
                  <TableCell sx={{ maxWidth: 200 }}>
                    {order.order_items
                      .map(
                        (v) => `${getItemBriefLabel(v.item)} x ${v.quantity}`,
                      )
                      .join(", ")}
                  </TableCell>
                  <TableCell
                    className="total-amount"
                    onClick={() => handleTotalClick(order.total)}
                  >
                    <abbr title={order.actual_total}>{order.total}</abbr>
                  </TableCell>
                  <TableCell>{formatDate(order.created_at)}</TableCell>
                  <TableCell align="right">
                    <Print
                      className="icon"
                      onClick={() => printNewReceipt(order, null)}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Container>
  );
};

export default Order;
